module.exports = __webpack_public_path__ + "static/media/survey.94947efa.svg";